import { lazy } from "react"

export const DispatcherOrderById = lazy(() => import("./DispatcherOrderById"))
